(() => {
  const money = (cents) =>
    `${(Number(cents) / 100).toLocaleString('pl-PL', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })} zł`;

  let productData = null;

  const fetchProduct = async () => {
    const handle = window.location.pathname.match(/\/products\/([^/?#]+)/)?.[1];
    if (!handle) return null;
    const response = await fetch(`/products/${handle}.js`);
    if (!response.ok) return null;
    return response.json();
  };

  const addPrices = (product) => {
    const variantsById = new Map(product.variants.map(v => [String(v.id), v]));

    const inputs = document.querySelectorAll([
      'variant-picker input[type="radio"]',
      'fieldset input[type="radio"]',
      '.variant-picker input[type="radio"]'
    ].join(', '));

    inputs.forEach((input) => {
      const label = input.closest('label') || document.querySelector(`label[for="${input.id}"]`);
      if (!label || label.querySelector('.variant-price-added')) return;

      const variantId = input.dataset.variantId || input.dataset.value;
      let variant = variantId ? variantsById.get(String(variantId)) : null;
      if (!variant) variant = product.variants.find(v => v.options?.includes(input.value));
      if (!variant) return;

      const priceSpan = document.createElement('span');
      priceSpan.className = 'variant-price-added';
      priceSpan.textContent = money(variant.price);
      priceSpan.style.fontSize = '0.85em';
      priceSpan.style.fontWeight = '600';
      priceSpan.style.display = 'block';
      priceSpan.style.width = '100%';
      priceSpan.style.textAlign = 'center';
      priceSpan.style.marginTop = '2px';
      priceSpan.style.color = '#666';

      label.style.flexDirection = 'column';
      label.style.alignItems = 'center';
      label.appendChild(priceSpan);
    });
  };

  const run = async () => {
    if (!productData) productData = await fetchProduct();
    if (!productData) return;
    addPrices(productData);
  };

  const observer = new MutationObserver(() => {
    if (productData) addPrices(productData);
  });

  const startObserver = () => {
    const picker = document.querySelector('variant-picker');
    if (picker && productData) {
      observer.observe(picker, { childList: true, subtree: true });
    }
  };

  const init = async () => {
    await run();
    startObserver();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();


